'use strict';

exports.__esModule = true;
exports.TptConnectError = exports.triggerFetches = exports.logger = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.schemaKey = schemaKey;
exports.normalizeParams = normalizeParams;
exports.requestKey = requestKey;
exports.isInState = isInState;
exports.findInState = findInState;
exports.fullUrl = fullUrl;
exports.normalizeResourceDefinition = normalizeResourceDefinition;
exports.computeExternalPayload = computeExternalPayload;
exports.extendFunction = extendFunction;
exports.subscribeToStore = subscribeToStore;
exports.fetchTreeData = fetchTreeData;
exports.query = query;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _normalizeUrl = require('normalize-url');

var _normalizeUrl2 = _interopRequireDefault(_normalizeUrl);

var _stringHash = require('string-hash');

var _stringHash2 = _interopRequireDefault(_stringHash);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _normalizr = require('normalizr');

var _actions = require('../actions');

var _denormalizr = require('denormalizr');

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sorts object alphabetically
 */
function _sortObject() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.keys(obj).sort().reduce(function (_obj, key) {
    _obj[key] = _typeof(obj[key]) === 'object' ? _sortObject(obj[key]) : obj[key];
    return _obj;
  }, {});
}

/**
 * Returns the normalizr schema key (ie 'item'/'items', etc) if there's a
 * schema, otherwise it returns 'default'
 */
function schemaKey(_ref) {
  var schema = _ref.schema;

  if (!schema) {
    return 'default';
  }
  return schema.getKey ? schema.getKey() : schema.getItemSchema().getKey();
}

function normalizeParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _qs2.default.stringify(params, { sort: function sort(a, b) {
      return a.localeCompare(b);
    } });
}

function defaultComputeKey(url, headers, method, body) {
  return [method, url, normalizeParams(headers), // TODO: lowercase header keys
  normalizeParams(body)].map(encodeURIComponent).join('|');
}

function requestKey(_ref2) {
  var url = _ref2.url,
      headers = _ref2.headers,
      method = _ref2.method,
      body = _ref2.body,
      _ref2$computeKey = _ref2.computeKey,
      computeKey = _ref2$computeKey === undefined ? defaultComputeKey : _ref2$computeKey;

  return (0, _stringHash2.default)(computeKey(url, headers, method, body));
}

function isInState(state, resourceDefinition) {
  return state && state.connect && state.connect.paramsToResources && state.connect.paramsToResources[resourceDefinition.requestKey] && !state.connect.paramsToResources[resourceDefinition.requestKey].meta.didInvalidate;
}

function findInState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { connect: {} };
  var resourceDefinition = arguments[1];
  var _state$connect = state.connect,
      _state$connect$params = _state$connect.paramsToResources,
      paramsToResources = _state$connect$params === undefined ? {} : _state$connect$params,
      _state$connect$resour = _state$connect.resources,
      resources = _state$connect$resour === undefined ? {} : _state$connect$resour;
  var isArray = resourceDefinition.isArray,
      defaultValue = resourceDefinition.defaultValue,
      schema = resourceDefinition.schema;

  var key = schemaKey(resourceDefinition);
  var resourceMap = paramsToResources[resourceDefinition.requestKey];
  var resourceKeys = resourceMap && resourceMap.data[key];

  if (!resourceKeys || resourceMap.meta.didInvalidate) {
    return false;
  }

  var mappedResources = resources[key] ? resourceKeys.map(function (id) {
    return resources[key][id];
  }) : resourceMap.data[key];

  if (!mappedResources) {
    mappedResources = defaultValue;
  } else if (!isArray) {
    mappedResources = mappedResources[0];
  }

  return {
    meta: resourceMap.meta,
    value: schema && resources[key] ? (0, _denormalizr.denormalize)(mappedResources, resources, schema) : mappedResources
  };
}

function fullUrl(url, params) {
  params && (url = url + '/?' + normalizeParams(params));
  return (0, _normalizeUrl2.default)(url, { stripWWW: false });
}

var logger = exports.logger = function () {
  var namespace = 'tptconnect';
  var error = (0, _debug2.default)(namespace + ':error');
  var info = (0, _debug2.default)(namespace + ':info');
  error.log = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return console.error ? Function.apply.call(console.error, console, args) : Function.apply.call(console.log, console, args);
  };
  info.log = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return console.info ? Function.apply.call(console.info, console, args) : Function.apply.call(console.log, console, args);
  };
  return { error: error, info: info };
}();

var definitionDefaults = {
  method: 'GET',
  normalize: _normalizr.normalize,
  actions: {},
  extends: {},
  clientOnly: false
};

function normalizeResourceDefinition(definition) {
  definition = _extends({}, definitionDefaults, definition.extends || {}, definition);

  (0, _invariant2.default)(definition.url !== undefined, 'Must include a URL for TpT-Connect to retrieve your resource');

  (0, _invariant2.default)(!/\?[^#]/.test(definition.url), 'Include query parameters under `params` in your resource definition ' + 'instead of directly in the URL. That will improve TpT-Connect\'s ability' + 'to cache your responses');

  if (typeof definition.schema === 'string') {
    definition.schema = new _normalizr.Schema(definition.schema);
  }

  definition.url = fullUrl(definition.url, definition.params);
  definition.method = definition.method.toUpperCase();
  definition.requestKey = requestKey(definition);

  if (definition.isArray === undefined) {
    definition.isArray = definition.schema && !definition.schema.getKey;
  }

  if (definition.defaultValue === undefined) {
    definition.defaultValue = definition.isArray ? [] : {};
  }

  if (definition.method === 'GET') {
    if (definition.auto === undefined) {
      definition.auto = true;
    }
    if (definition.updateStrategy === undefined) {
      definition.updateStrategy = 'replace';
    }
  }

  return definition;
}

function computeExternalPayload(resourceDefinition, json) {
  return (0, _actions.computePayload)(normalizeResourceDefinition(resourceDefinition), { isError: false, isSuccess: true }, json);
}

function extendFunction() {
  var _this = this;

  for (var _len3 = arguments.length, functions = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    functions[_key3] = arguments[_key3];
  }

  return function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    for (var _iterator = functions, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref3 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref3 = _i.value;
      }

      var func = _ref3;

      typeof func === 'function' && func.apply(_this, args);
    }
  };
}

/**
 * Traverse a react tree and trigger all tpt-connect fetches so we dont have to
 * render twice
 *
 * idea taken from react-apollo
 * https://github.com/apollostack/react-apollo/blob/master/src/server.ts
 */
var triggerFetches = exports.triggerFetches = function () {
  // IIFE
  // If we're handling a stateless component we still need to traverse its
  // children. React uses a similar solution where it wraps it in a class and
  // gives it a `render` method.
  //
  // See:
  // https://github.com/facebook/react/blob/v15.0.1/src/renderers/shared/reconciler/ReactCompositeComponent.js#L43-L50
  // https://github.com/facebook/react/blob/v15.0.1/src/renderers/shared/reconciler/ReactCompositeComponent.js#L186-L198
  var StatelessComponent = function () {
    function StatelessComponent(Component, props, context) {
      _classCallCheck(this, StatelessComponent);

      this.Component = Component;
      this.props = props;
      this.context = context;
    }

    StatelessComponent.prototype.render = function render() {
      // eslint-disable-next-line new-cap
      return this.Component(this.props, this.context, this.updater);
    };

    return StatelessComponent;
  }();

  // eslint-disable-next-line no-shadow


  return function triggerFetches(component) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!component) {
      return;
    }

    if (typeof component === 'function') {
      // stateless
      component = { type: component };
    }

    var _component = component,
        Component = _component.type,
        _component$props = _component.props,
        props = _component$props === undefined ? {} : _component$props; // TODO: can we get context here too?

    if (typeof Component !== 'function') {
      // html el?
      _react.Children.forEach(props.children, function (child) {
        triggerFetches(child, context);
      });
    } else {
      (function () {
        // react component
        var ownProps = _extends({}, Component.defaultProps || {}, props);

        var inst = Component.prototype.render ? new Component(ownProps, context) : new StatelessComponent(Component, ownProps, context); // stateless

        try {
          // not sure why we need these
          inst.props = ownProps;
          inst.context = context;
          inst.setState = function (newState) {
            // simplify setState
            inst.state = _extends({}, inst.state, newState);
          };
        } catch (e) {}

        // triggers fetch if tptconnect component
        if (inst.componentWillMount) {
          inst.componentWillMount();
        }

        if (inst.getChildContext) {
          context = _extends({}, context, inst.getChildContext());
        }

        var child = inst.render();

        triggerFetches(child, context);
      })();
    }
  };
}();

/**
 * Returns a promise which resolves when all tpt-connect requests have finished
 */
function subscribeToStore(store) {
  return new Promise(function (resolve, reject) {
    var _store$getState$conne = store.getState().connect.isAllFetched,
        isAllFetched = _store$getState$conne === undefined ? true : _store$getState$conne;

    if (isAllFetched) {
      resolve();
      return;
    }

    var unsubscribe = store.subscribe(function () {
      var state = store.getState();

      if (state.connect.error) {
        unsubscribe();
        reject({
          err: state.connect.error,
          response: state.connect.lastResponse
        });
        return;
      }

      if (state.connect.isAllFetched) {
        unsubscribe();
        resolve();
        return;
      }
    });
  });
}

/**
 * Subscribing to store changes so we can determine when tpt-connect is
 * done fetching its data before we re-render
 */
function fetchTreeData(reactTree, store) {
  triggerFetches(reactTree);
  return subscribeToStore(store);
}

function query(resourceDefinition, store) {
  resourceDefinition = normalizeResourceDefinition(resourceDefinition);
  store.dispatch((0, _actions.prepopulateResource)(resourceDefinition));
  store.dispatch((0, _actions.dispatchRequest)(resourceDefinition, {}));
  return subscribeToStore(store);
}

var TptConnectError = exports.TptConnectError = function (_Error) {
  _inherits(TptConnectError, _Error);

  function TptConnectError(message, opts) {
    _classCallCheck(this, TptConnectError);

    var _this2 = _possibleConstructorReturn(this, _Error.call(this, message));

    _this2.response = opts.response;
    _this2.responseBody = opts.responseBody;

    // backward compatibility
    _this2.error = _this2;
    return _this2;
  }

  return TptConnectError;
}(Error);